
const getAxiosError = (err) => {
    if (err.response) {
        err = err.response;
        err = err.data || {};
        err = err.exception || err;
        return err.error || err;
    }
    return err;
}

export { getAxiosError }